(() => {
  (() => {
    const links = document.querySelectorAll('a');
    const root = Shopify.routes.root.replace(/\/+$/, '');
    links.forEach((a) => {
      if (a.href.includes(Shopify.shop) && root && root != '/' && !a.href.includes(root)) {
        a.href = a.href.replace(Shopify.shop, Shopify.shop + root);
      }
    });
  })();

  function debounce(fn, delay3) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay3);
    };
  }
  window._debounce = debounce;
  function initAOS() {
    AOS.init({
      disable: 'mobile',
      easing: 'ease',
      offset: 200,
      duration: 500,
      startEvent: 'DOMContentLoaded',
      // once: true,
    });
  }
  initAOS();

  // 公共类可继承open属性
  const GlobalHTMLElement = class extends HTMLElement {
    static get observedAttributes() {
      return ['open'];
    }
    constructor() {
      super();
    }
    get open() {
      return this.hasAttribute('open');
    }
    set open(value) {
      if (value) {
        (async () => {
          this.setAttribute('open', '');
        })();
      } else {
        this.removeAttribute('open');
      }
    }
    listenerKeydown() {
      document.addEventListener('keydown', (e) => {
        if (this.open == true && e.code == 'Escape') {
          this.open = false;
        }
      });
    }
  };

  // swiper-component 自定义轮播组件
  customElements.define(
    'swiper-component',
    class SwiperComponent extends GlobalHTMLElement {
      custom_pagination = { total: 0, current: 0 };
      swiper_options = {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: false,
        autoplay: false,
        watchOverflow: true,
        speed: 500, // 动画时间，单位 ms
      };

      constructor() {
        super();
        this.lock = true; // 控制组件只初始化一次
        this.custom_prev_btn = this.querySelector('.swiper-pagination-prev');
        this.custom_next_btn = this.querySelector('.swiper-pagination-next');
        this.custom_swiper_tabs = this.querySelectorAll('.swiper-tab-item');
      }

      disconnectedCallback() {
        this.swiper.destroy(true, true);
      }

      connectedCallback() {}

      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'open' && this.hasAttribute('open') && this.lock) {
          this.lock = false;
          this.startSwiper();
        }
      }

      startSwiper() {
        this.initPagination();
        this.initSwiper();
        this.initCuPaginationButton();

        // 边界滚动处理
        if (this.swiper_options.mousewheel && this.swiper_options.mousewheel.releaseOnEdges) {
          this.releaseOnEdges(); // PC 滚轮
          this.releaseOnEdgesMobile(); // 移动端 touch
        }
      }

      initSwiper() {
        Object.keys(this.dataset).forEach((key) => {
          this.swiper_options[key] = JSON.parse(this.dataset[key]);
        });

        this.swiper = new Swiper(this.querySelector('.swiper'), {
          ...this.swiper_options,
          touchStartPreventDefault: false,
          passiveListeners: true,
        });

        this.swiper['custom_pagination'] = this.custom_pagination;

        this.swiper.on('slideChange', (item) => {
          this.custom_pagination.current = item.realIndex + 1;
          this.swiper['custom_pagination'] = this.custom_pagination;
          this.updateCuPaginationButton();
          this.selectTabsItem(item.realIndex);
        });

        // When a slide (variant) is clicked, on desktop reposition so clicked becomes centered in the visible window
        this.swiper.on('click', (swiperEvent) => {
          try {
            const clickedIndex = this.swiper.clickedIndex;
            if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;

            // Determine slidesPerView (may be fractional or responsive in params)
            const dsRaw = this.dataset.slidesPerView || this.swiper.params.slidesPerView || 3;
            const ds = Number(dsRaw);
            const visibleCount = Math.max(1, Math.floor(ds));

            // center offset (number of items to the left of center)
            const centerOffset = Math.floor(visibleCount / 2);

            // target start index so clickedIndex appears centered
            let target = clickedIndex - centerOffset;

            // clamp target within valid range
            const maxStart = Math.max(0, this.swiper.slides.length - visibleCount);
            if (target < 0) target = 0;
            if (target > maxStart) target = maxStart;

            // Only apply on desktop
            if (window.innerWidth >= 1024) {
              const speed = this.swiper.params.speed || 500;
              this.swiper.slideTo(target, speed);
            }
          } catch (e) {
            console.error('swiper click reposition (center) error', e);
          }
        });
      }

      slideTo(index) {
        this.swiper.slideTo(index);
      }

      initPagination() {
        if (
          this.querySelector('.swiper-button-next') &&
          this.querySelector('.swiper-button-prev')
        ) {
          this.swiper_options.navigation = {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          };
        }
        if (this.querySelector('.swiper-pagination')) {
          this.swiper_options.pagination = {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          };
        }
        if (this.querySelector('.swiper-pagination.swiper-pagination-dynamicBullets')) {
          this.swiper_options.pagination = {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            dynamicBullets: true,
          };
        }
        if (this.querySelector('.swiper-pagination-custom')) {
          const _this = this;
          this.swiper_options.pagination = {
            el: this.querySelector('.swiper-pagination-custom'),
            clickable: true,
            type: 'custom',
            renderCustom: function (swiper, current, total) {
              _this.custom_pagination = { current, total };
              return null;
            },
          };
        }
      }

      initCuPaginationButton() {
        if (this.custom_next_btn && this.custom_prev_btn) {
          this.updateCuPaginationButton();
          this.custom_prev_btn.onclick = () => {
            this.swiper.slidePrev();
            this.updateCuPaginationButton();
          };
          this.custom_next_btn.onclick = () => {
            this.swiper.slideNext();
            this.updateCuPaginationButton();
          };
        }
        if (this.custom_swiper_tabs.length) {
          this.selectTabsItem(0);
          this.custom_swiper_tabs.forEach((item, index) => {
            item.onclick = () => this.selectTabsItem(index);
          });
        }
      }

      selectTabsItem(index) {
        if (this.custom_swiper_tabs.length) {
          $(this.custom_swiper_tabs).not(this.custom_swiper_tabs[index]).removeClass('active');
          this.custom_swiper_tabs[index].classList.add('active');
          this.swiper.slideTo(index);
        }
      }

      updateCuPaginationButton() {
        if (!this.custom_next_btn && !this.custom_prev_btn) return;
        this.custom_prev_btn.disabled = this.swiper.activeIndex === 0;
        this.custom_next_btn.disabled = this.swiper.isEnd;
      }

      // ---------------- PC 滚轮边界逻辑 ----------------
      releaseOnEdges() {
        const swiperEl = this.querySelector('.swiper');
        swiperEl.addEventListener(
          'wheel',
          (e) => {
            const s = this.swiper;
            const delta = e.deltaY;

            if (s.animating) {
              e.preventDefault();
              return;
            }
            if (s.isEnd && delta > 0) return;
            if (s.isBeginning && delta < 0) return;
          },
          { passive: false }
        );
      }

      // ---------------- 移动端 touch + 动画锁 ----------------
      releaseOnEdgesMobile() {
        const swiperEl = this.querySelector('.swiper');
        let startY = 0;
        let lock = false; // 动画锁，保证切片动画完成前不触发下一次

        swiperEl.addEventListener(
          'touchstart',
          (e) => {
            startY = e.touches[0].clientY;
          },
          { passive: true }
        );

        swiperEl.addEventListener(
          'touchend',
          (e) => {
            if (lock) return; // 动画锁定中，不响应
            const delta = startY - e.changedTouches[0].clientY;
            const s = this.swiper;
            const threshold = 30; // 最小滑动距离

            if (Math.abs(delta) < threshold) return;

            if (delta > 0) {
              // 上滑
              if (!s.isEnd) {
                lock = true;
                s.slideNext();
                s.once('transitionEnd', () => {
                  lock = false;
                });
              } else {
                // 滑完最后一张再滚动页面
                window.scrollBy({ top: delta, behavior: 'smooth' });
              }
            } else {
              // 下滑
              if (!s.isBeginning) {
                lock = true;
                s.slidePrev();
                s.once('transitionEnd', () => {
                  lock = false;
                });
              } else {
                window.scrollBy({ top: delta, behavior: 'smooth' });
              }
            }
          },
          { passive: true }
        );
      }
    }
  );

  class HeaderNavigation extends HTMLElement {
    constructor() {
      super();
      this.init();
      this.listenerHover();
    }
    init() {
      if (location.pathname == '/') {
        const header = document.querySelector('.header_sticky.shopify-section--header');
        const announcement = document.querySelector('.header-announcement--content');
        const navHeight = announcement?.clientHeight || 0;
        const isTopHeader = () => {
          if ((window.scrollY || window.pageYOffset) > header.clientHeight + navHeight) {
            header.classList.remove('is--home');
          } else {
            header.classList.add('is--home');
          }
        };
        isTopHeader();
        window.addEventListener('scroll', (e) => {
          isTopHeader();
        });
      }
    }
    listenerHover() {
      const header_menus = this.querySelectorAll('.header-menu');
      const items = this.querySelectorAll('.header-menu--hover');


      const imgCache = {};
      items.forEach(item => {
        const img = new Image();
        img.src = item.dataset.hoverImg;
        imgCache[item.dataset.hoverImg] = img;
      });


      $(header_menus).hover(
        function () {
          const drop_container = this.querySelector('.header-menu-drop-container');
          const dropRight = drop_container.querySelector('.header-menu-drop-right--bg');
          if (!dropRight) return;

          $(items).hover(
            function () {
              const newBg = `url(${this.dataset.hoverImg})`;

              // 只有背景不同才切换
              if (dropRight.style.backgroundImage !== newBg) {
                dropRight.style.backgroundImage = newBg;
              }

              dropRight.classList.add('active');
              dropRight.querySelector('#right--title').innerHTML = this.dataset.hoverTitle;
            },
            function () {
              dropRight.classList.remove('active');
            }
          );
        },
        function () {
          // const drop_container = this.querySelector('.header-menu-drop-container')
          // drop_container.classList.add('hidden')
        }
      );
    }

  }

  customElements.define('header-navigation', HeaderNavigation);

  if (!customElements.get('mobile-menu-navigation')) {
    customElements.define(
      'mobile-menu-navigation',
      class MobileMenuNavigation extends GlobalHTMLElement {
        static get observedAttributes() {
          return ['open'];
        }
        constructor() {
          super();
          this.listenerClick();
          this.initDrop = true;
        }

        attributeChangedCallback(name, oldValue, newValue) {
          switch (name) {
            case 'open':
              this.initDrop && this.initDrawer();
              this.open
                ? document.body.classList.add('overflow-hidden')
                : document.body.classList.remove('overflow-hidden');
          }
        }
        listenerClick() {
          this.mobile_menu_items = this.querySelectorAll('.mobile-menu-item');
          this.mobile_menu_items.forEach((item) => {
            item.addEventListener('click', () => {
              $(this.mobile_menu_items).not(item).removeClass('active');
              item.classList.add('active');
            });
          }); //
        }
        initDrawer() {
          this.mobile_menu_items.forEach((item) => {
            if (item.querySelector('.mobile-menu-drop-container') && this.initDrop) {
              this.initDrop = false;
              item.classList.add('active');
            }
          });
        }
      }
    );
  }

  // 视频监控组件
  customElements.define(
    'listener-video-status',
    class ListenerVideoStatus extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector('video');
        this.video_btns = this.querySelectorAll('.video-icon');
        this.initVideo();
      }

      initObserver() {
        // const _this = this;
        // this.videoObserver = new IntersectionObserver(function (
        //     entries,
        //     observer
        // ) {
        //     entries.forEach((entry) => {
        //         if (entry.isIntersecting) {
        //             _this.videoPlay(entry.target);
        //         } else {
        //             _this.videoPause(entry.target);
        //         }
        //     });
        // });
      }
      initVideo() {
        // this.initObserver();

        // this.videoObserver.observe(this.video);
        //playing：当视频在已因缓冲而暂停或停止后已就绪时触发
        this.video.addEventListener('playing', function () {});

        // 播放监听
        this.video.addEventListener('play', function () {
          // this.hideReplayIcon();
        });

        // 暂停监听
        this.video.addEventListener('pause', function () {
          // this.videoPause(this.video);
        });
        this.video_btns.forEach((item) => {
          item.addEventListener('click', () => {
            $(this.video_btns).not(item).addClass('active');
            item.classList.remove('active');
            this.selectActive(item.dataset.type);
          });
        });
      }
      selectActive(type) {
        this.video.autoplay = false;
        type == 'play' ? this.video.play() : this.video.pause();
      }
    }
  );

  // 轮播图上下切换按钮组件(含当前页数)
  customElements.define(
    'swiper-button-pagination',
    class SwiperComponent extends HTMLElement {
      constructor() {
        super();
        this.swiper = document.getElementById(this.dataset.sectionId)?.swiper ?? {};
        this.current_dom = this.querySelector('.swiper-button-pagination-current');
        this.total_dom = this.querySelector('.swiper-button-pagination-total');
        this.prev_btn = this.querySelector('.swiper-button-pagination-prev');
        this.next_btn = this.querySelector('.swiper-button-pagination-next');
        this.selectActive();
        this.init();
      }

      init() {
        this.prev_btn.addEventListener('click', () => {
          this.swiper.slidePrev();
        });
        this.next_btn.addEventListener('click', () => {
          this.swiper.slideNext();
        });
        this.swiper.on('slideChange', (item) => {
          this.selectActive();
        });

        window.addEventListener(
          'resize',
          debounce(() => {
            this.selectActive();
          }, 400)
        );
      }
      selectActive() {
        this.current_dom.innerText = this.swiper.custom_pagination.current;
        this.total_dom.innerText = this.swiper.custom_pagination.total;
        this.prev_btn.disabled = this.swiper.activeIndex == 0;
        this.next_btn.disabled = this.swiper.isEnd;
      }
    }
  );

  // 唤醒弹窗按钮 需传入对应弹窗id
  class GlobalModalButton extends HTMLElement {
    constructor() {
      super();
      // this.initContent()
    }
    connectedCallback() {
      if (!this.dataset.id) return;
      const modalContainer = document.getElementById(this.dataset.id);
      this.addEventListener('click', () => {
        modalContainer.toggleAttribute('open', !modalContainer.open);
        this.setAttribute(
          'aria-expanded',
          this.getAttribute('aria-expanded') == 'false' ? true : false
        );
      });
      modalContainer.addEventListener('click', (element) => {
        if (element.target == modalContainer && modalContainer.open == true) {
          modalContainer.open = false;
        }
      });
    }
  }
  customElements.define('global-modal-button', GlobalModalButton);

  /* 产品集合弹窗 {% render 'product-collection-modal',
      modal_id: item.id,
      modal_contents: modal_contents,
      modal_products: modal_products,
      index: forloop.index
    %}
    */
  customElements.define(
    'product-collection-modal',
    class ProductCollectionModal extends GlobalHTMLElement {
      constructor() {
        super();
        this.swiperLock = true;
        this.init();
      }

      attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
          case 'open':
            this.open
              ? document.body.classList.add('overflow-hidden')
              : document.body.classList.remove('overflow-hidden');
            super.listenerKeydown();
        }
      }
      init() {
        this.querySelector('.close-modal').addEventListener('click', () => {
          this.open = false;
        });
      }
    }
  );

  // 加购按钮
  customElements.define(
    'add-cart-button',
    class AddCartButton extends HTMLElement {
      constructor() {
        super();
        this.isProcessing = false;
        this.init();
      }

      init() {
        this.addEventListener('click', () => {
          this.addToCart(this.dataset.variantId);
        });
      }
      addToCart(variantId) {
        // 防止重复点击
        if (this.isProcessing) {
          return;
        }
        this.isProcessing = true;

        const _this = this;
        let formData = {
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
        };
        this.classList.add('loading');
        this.style.pointerEvents = 'none';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((res) => {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  cart: res,
                  openMiniCart: true,
                },
              })
            );
          })
          .catch((error) => {
            console.error('[AddCartButton] Error:', error);
          })
          .finally(() => {
            _this.classList.remove('loading');
            _this.style.pointerEvents = '';
            _this.isProcessing = false;
          });
      }
    }
  );

  // customElements.define(
  //   'image-lazy-load',
  //   class ImageLazyLoad extends HTMLElement {
  //     constructor() {
  //       super();
  //       this.images = document.querySelectorAll('.img--lazyload');
  //       this.initImageLazyLoad();
  //     }

  //     initImageLazyLoad() {
  //       if ('IntersectionObserver' in window) {
  //         const lazyImageObserver = new IntersectionObserver(function (entries, observer) {
  //           entries.forEach((entry) => {
  //             if (entry.isIntersecting) {
  //               let lazyImage = entry.target;
  //               lazyImage.src = lazyImage.dataset.src;
  //               lazyImage.classList.add('lazyloaded');
  //               observer.unobserve(entry.target);
  //               // 重新计算动画位置
  //               AOS?.refreshHard();
  //             }
  //           });
  //         });

  //         this.images.forEach((item) => {
  //           lazyImageObserver.observe(item);
  //         });
  //       } else {
  //         let active = false;
  //         const _this = this;
  //         let lazyLoad = () => {
  //           if (active === false) {
  //             active = true;
  //             setTimeout(() => {
  //               _this.images.forEach((lazyImage) => {
  //                 if (
  //                   lazyImage.getBoundingClientRect().top <= window.innerHeight &&
  //                   lazyImage.getBoundingClientRect().bottom >= 0 &&
  //                   getComputedStyle(lazyImage).display !== 'none'
  //                 ) {
  //                   lazyImage.src = lazyImage.dataset.src;
  //                   // lazyImage.classList.remove("lazy");
  //                   lazyImage.classList.add('lazyloaded');
  //                   _this.images = _this.images.filter((image) => {
  //                     return image !== lazyImage;
  //                   });
  //                   if (_this.images.length === 0) {
  //                     document.removeEventListener('scroll', lazyLoad);
  //                     window.removeEventListener('resize', lazyLoad);
  //                     window.removeEventListener('orientationchange', lazyLoad);
  //                   }
  //                 }
  //               });
  //               active = false;
  //             }, 200);
  //           }
  //         };
  //         document.addEventListener('scroll', lazyLoad);
  //         window.addEventListener('resize', lazyLoad);
  //         window.addEventListener('orientationchange', lazyLoad);
  //       }
  //     }
  //   }
  // );

  customElements.define(
    'image-lazy-load',
    class ImageLazyLoad extends HTMLElement {
      constructor() {
        super();
        // 获取所有懒加载图片
        this.images = document.querySelectorAll('.img--lazyload');
        // 定义预加载距离（ 提前 2.5 屏）
        this.preloadScreens = 2.5;
        this.preloadOffset = window.innerHeight * this.preloadScreens;

        this.initImageLazyLoad();
      }

      initImageLazyLoad() {
        if ('IntersectionObserver' in window) {
          const lazyImageObserver = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  const lazyImage = entry.target;
                  lazyImage.src = lazyImage.dataset.src;
                  lazyImage.classList.add('lazyloaded');
                  observer.unobserve(entry.target);
                  AOS?.refreshHard?.();
                }
              });
            },
            {
              rootMargin: '250% 31.25%',
            }
          );

          this.images.forEach(item => lazyImageObserver.observe(item));

        } else {
          let active = false;
          const _this = this;

          const lazyLoad = () => {
            if (!active) {
              active = true;

              setTimeout(() => {
                _this.images.forEach(lazyImage => {
                  const rect = lazyImage.getBoundingClientRect();

                  if (
                    rect.top <= window.innerHeight + _this.preloadOffset &&
                    rect.bottom >= -_this.preloadOffset &&
                    getComputedStyle(lazyImage).display !== 'none'
                  ) {
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.add('lazyloaded');
                    _this.images = Array.from(_this.images).filter(img => img !== lazyImage);

                    if (_this.images.length === 0) {
                      document.removeEventListener('scroll', lazyLoad);
                      window.removeEventListener('resize', lazyLoad);
                      window.removeEventListener('orientationchange', lazyLoad);
                    }
                  }
                });
                active = false;
              }, 200);
            }
          };
          document.addEventListener('scroll', lazyLoad);
          window.addEventListener('resize', lazyLoad);
          window.addEventListener('orientationchange', lazyLoad);
        }
      }
    }
  );


  customElements.define(
    'bg-image-lazy-load',
    class GgImageLazyLoad extends HTMLElement {
      constructor() {
        super();
        this.bgElements = this.querySelectorAll('.bg-lazyload');
        // 记录已加载的元素，用于窗口大小变化时重新设置背景
        this.loadedElements = new Set();
      }

      connectedCallback() {
        this.init();
        this.bindResizeEvent();
      }

      getImageSrc(element) {
        const mobileSrc = element.dataset.srcMobile;
        const pcSrc = element.dataset.src;
        const isMobile = window.matchMedia('(max-width: 750px)').matches;
        return isMobile && mobileSrc ? mobileSrc : pcSrc;
      }

      setBackground(element) {
        element.style.backgroundImage = `url(${this.getImageSrc(element)})`;
        element.style.backgroundSize = element.dataset.size || 'cover';
      }

      init() {
        if ('IntersectionObserver' in window) {
          const lazyObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                let element = entry.target;
                this.setBackground(element);
                this.loadedElements.add(element);
                observer.unobserve(entry.target);
              }
            });
          });
          this.bgElements.forEach((item) => {
            lazyObserver.observe(item);
          });
        } else {
          // 降级方案：直接加载全部
          this.bgElements.forEach((item) => {
            this.setBackground(item);
            this.loadedElements.add(item);
          });
        }
      }

      bindResizeEvent() {
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            this.loadedElements.forEach((element) => {
              this.setBackground(element);
            });
          }, 200); // 防抖
        });
      }
    }
  );

  customElements.define(
    'detail-info-list',
    class DetailInfoList extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        $(this.querySelectorAll('.list-info-header')).click(function () {
          $(this).next('.list-info-content').slideToggle();
          $(this).toggleClass('open');
        });
      }
    }
  );

  class FieldInput extends HTMLElement {
    constructor() {
      super();
      this.labelInput = this.querySelector('.field--input');
      this.allow_clear = this.querySelector('.allow--clear');
      if (!this.labelInput) return;
      // const select = this.querySelector('select')
      // const textarea = this.querySelector('textarea')
      this.init();
      this.handleChange();
      this.allowClear();
    }

    init() {
      this.addEventListener('mouseenter', () => {
        this.allowClearShow(!!this.labelInput.value);
      });
      this.addEventListener('mouseleave', () => {
        this.allowClearShow(false);
      });
    }
    handleChange() {
      this.labelInput.addEventListener('input', (e) => {
        this.allowClearShow(!!e.target.value);
      });
    }
    allowClear() {
      this.allow_clear.addEventListener('click', () => {
        this.labelInput.value = null;
        this.allowClearShow(false);
        this.labelInput.dispatchEvent(
          new CustomEvent('clear-input', {
            bubbles: true,
          })
        );
      });
    }
    allowClearShow(flag) {
      flag
        ? this.allow_clear.classList.add('visible')
        : this.allow_clear.classList.remove('visible');
    }
  }
  customElements.define('field-input', FieldInput);
  class FieldSelect extends FieldInput {
    constructor() {
      super();
      this.selectDown = this.querySelector('.field-select--down');
      this.updateInputValue(null, false);
      this.initSelectItem();
      this.initFieldSelect();
    }
    initSelectItem() {
      let fragment = document.createDocumentFragment();
      let jsonString = this.querySelector('#options--json').innerText.trim();
      let jsonMessage = this.querySelector('#options--message')?.innerText.trim();
      this.message = JSON.parse(jsonMessage ?? '[]');
      let options = JSON.parse(jsonString);
      options.forEach((item, index) => {
        const div = document.createElement('div');
        div.classList.add('field-select--option');
        div.setAttribute('data-value', item.value);
        div.setAttribute('data-label', item.label);
        div.innerText = item.label;
        div.addEventListener('click', () => {
          this.selectOption(div);
          if (this.message.length) {
            this.showMessage(index, item.label);
          }
        });
        fragment.appendChild(div);
      });
      this.selectDown.appendChild(fragment);
      this.sectionOptions = this.selectDown.querySelectorAll('.field-select--option');
    }
    showMessage(index, label, flag = true) {
      let messageEle = this.querySelector('.field--message');
      if (flag) {
        messageEle.classList.remove('hidden');
        let cuMessage = this.message[index];
        this.querySelector('.field--message').innerText = cuMessage.replace('$_$', `"${label},"`);
      } else {
        messageEle.classList.add('hidden');
      }
    }
    initFieldSelect() {
      this.labelInput.addEventListener('click', (e) => {
        this.selectDownShow();
      });

      this.labelInput.addEventListener('clear-input', () => {
        this.updateInputValue(null, false);
        $(this.sectionOptions).removeClass('active');
        this.showMessage(null, null, false);
      });

      document.addEventListener('click', (e) => {
        if (e.target !== this.labelInput && this.selectDown.classList.contains('visible')) {
          this.selectDownShow();
        }
      });
    }

    updateInputValue(data, flag = true) {
      this.initValues = data || {
        value: '',
        label: '',
      };
      this.labelInput.setAttribute('data-value', JSON.stringify(this.initValues));
      this.labelInput.value = this.initValues.label;
      // flag是否需要触发input-select
      flag &&
        this.labelInput.dispatchEvent(
          new CustomEvent('input-select', {
            bubbles: true,
            detail: {
              element: this.labelInput,
              data: this.initValues,
            },
          })
        );
    }

    selectOption(element) {
      if (element.dataset.value == this.initValues.value) return;
      element.classList.add('active');
      $(this.sectionOptions).not(element).removeClass('active');
      this.updateInputValue({
        value: element.dataset.value,
        label: element.dataset.label,
      });
    }

    selectDownShow(flag) {
      this.selectDown.classList.toggle('visible');
    }
  }
  customElements.define('field-select', FieldSelect);

  class FieldSelectGlobal extends FieldInput {
    constructor(apiKey) {
      super();
      this.apiKey = apiKey || this.dataset.apiKey;
      this.params = {
        $pageindex: 1,
        $pagesize: 15,
      };
      this.fetchLock = true;
      this.isOneDown = true;
      this.selectDown = this.querySelector('.field-select--down');
      // this.hiddenInput = this.querySelector('.field--input-hidden')
      this.spanLabel = this.querySelector('.field--input--label');
      this.labelInput = this.querySelector('.field--input');
      this.empty = this.querySelector('.field-select--empty');
      this.loading = this.querySelector('.rotation-loading');
      this.initInputValue();
      this.clearHandle();
      this.listenerHandleClick();
      this.initSelectGlobal();
    }
    initSelectGlobal() {
      if (this.hasAttribute('autofetch')) {
        this.getFetchData({ $pagesize: 1000, $orderby: 'new_name asc' });
      }
    }

    async getFetchData(query = {}, isUpdateQuery = false) {
      if (!this.apiKey) return new Error('apiKey 不能为空');
      try {
        if (isUpdateQuery || this.fetchLock) {
          this.initQuery = { ...this.params, ...query };
          this.fetchLock = false;
        }
        let params = {
          ...this.params,
          ...query,
        };
        this.loading.classList.remove('hidden');
        const res = await window.fscloud.fetchServer(`api/dynamic/${this.apiKey}`, params);
        const data =
          res.Data?.Entities?.map((item) => {
            return {
              label: item.name || item.new_name,
              value: item.$id,
              logicalname: item.$logicalname,
            };
          }) ?? [];
        this.fetchData = data ?? [];
        if (!this.isOneDown) {
          this.renderDown(data);
        }
      } catch (error) {
        console.error('error', error);
      } finally {
        this.loading.classList.add('hidden');
      }
    }
    initInputValue() {
      this.initValues = {
        value: '',
        label: '',
        logicalname: '',
      };
    }

    clearHandle() {
      this.allow_clear.addEventListener('click', () => {
        $(this.sectionOptions).removeClass('active');
        this.updateInputValue('', true);
        // readonly只可读的input不需要重新请求数据
        if (!this.labelInput.hasAttribute('readonly')) {
          this.getFetchData(this.initQuery);
        }
      });
    }

    renderDown(entities = this.fetchData) {
      $(this.selectDown.querySelectorAll('.field-select--option')).remove();
      entities?.length ? this.empty.classList.add('hidden') : this.empty.classList.remove('hidden');

      if (!entities?.length) return;

      let fragment = document.createDocumentFragment();
      entities.forEach((item) => {
        const div = document.createElement('div');
        div.classList.add('field-select--option');
        div.setAttribute('data-value', item.value);
        div.setAttribute('data-label', item.label);
        div.setAttribute('data-logicalname', item.logicalname);
        div.innerText = item.label;
        fragment.appendChild(div);
      });

      this.selectDown.appendChild(fragment);
      this.sectionOptions = this.selectDown.querySelectorAll('.field-select--option');
      this.initFieldSelect();
    }

    listenerHandleClick() {
      this.labelInput.addEventListener('click', (e) => {
        this.selectDownShow(true);
        if (this.isOneDown) {
          this.isOneDown = false;
          this.renderDown();
        }
      });
      this.labelInput.addEventListener('blur', () => {
        if (!this.fetchData?.length) {
          this.getFetchData(this.initQuery);
        }
        this.updateInputValue(this.initValues, false);
      });
      this.labelInput.addEventListener('focus', () => {
        this.selectDownShow(true);
      });
      document.addEventListener('click', (e) => {
        if (e.target !== this.labelInput && this.selectDown.classList.contains('visible')) {
          this.selectDownShow(false);
        }
      });
    }

    initFieldSelect() {
      this.sectionOptions.forEach((item) => {
        item.addEventListener('click', () => {
          this.selectOption(item);
        });
      });
    }

    updateInputValue(data, flag = true) {
      this.initValues = data || {
        value: '',
        label: '',
      };
      // this.hiddenInput.value = JSON.stringify(this.initValues)
      this.labelInput.setAttribute('data-value', JSON.stringify(this.initValues));
      this.labelInput.value = this.initValues.label;
      // this.spanLabel.innerText = this.initValues.label
      // flag是否需要触发input-select
      flag &&
        this.labelInput.dispatchEvent(
          new CustomEvent('input-select', {
            bubbles: true,
            detail: {
              element: this.labelInput,
              data: this.initValues,
            },
          })
        );
    }

    selectOption(item) {
      if (item.dataset.value == this.initValues.value) return;
      item.classList.add('active');
      $(this.sectionOptions).not(item).removeClass('active');
      this.updateInputValue({
        value: item.dataset.value,
        label: item.dataset.label,
        logicalname: item.dataset.logicalname,
      });
    }

    selectDownShow(flag) {
      flag ? this.selectDown.classList.add('visible') : this.selectDown.classList.remove('visible');
      // this.selectDown.classList.toggle('visible')
    }
  }

  customElements.define('field-select-global', FieldSelectGlobal);

  class FieldSelectProvince extends FieldSelectGlobal {
    constructor() {
      super();
      this.initContent();
    }

    initContent() {
      this.updateInput();
      // 监听国家选项
      const fieldInput = document
        .querySelector('#new_country--select')
        .querySelector('.field--input');
      fieldInput.addEventListener('input-select', (e) => {
        if (e.detail.data.value) {
          this.getFetchData(
            { $pagesize: 1500, $filter: `new_country_id/id eq ${e.detail.data.value}` },
            true
          );
        }
        this.updateInput(e.detail.data.value);
      });
    }
    updateInput(new_country_id) {
      this.updateInputValue('', false);
      this.labelInput.disabled = !new_country_id;
    }
  }

  customElements.define('field-select-province', FieldSelectProvince);

  class FieldSelectCity extends FieldSelectGlobal {
    constructor() {
      super();
      this.initContent();
    }

    initContent() {
      // 国外选项
      const external_item = document.querySelector('#city_external_item');
      this.external_input = external_item.querySelector('.field--input');
      // 国内选项
      const internal_item = document.querySelector('#city_internal_item');
      //国家变动监听
      const countryInput = document
        .querySelector('#new_country--select')
        .querySelector('.field--input');

      this.updateInput();

      countryInput.addEventListener('input-select', (e) => {
        if (e.detail.data.label == 'China') {
          internal_item.classList.remove('hidden');
          external_item.classList.add('hidden');
        } else {
          internal_item.classList.add('hidden');
          external_item.classList.remove('hidden');
        }
        this.updateInput();
      });
      //省变动监听
      const provinceInput = document
        .querySelector('#new_province--select')
        .querySelector('.field--input');
      provinceInput.addEventListener('input-select', (e) => {
        if (e.detail.data.value) {
          this.getFetchData(
            { $pagesize: 1500, $filter: `new_province_id/id eq ${e.detail.data.value}` },
            true
          );
        }
        this.updateInput(e.detail.data.value);
      });
    }
    updateInput(new_province_id) {
      this.updateInputValue('', false);
      this.labelInput.disabled = !new_province_id;
      this.external_input.value = '';
      this.external_input.disabled = !new_province_id;
    }
  }

  customElements.define('field-select-city', FieldSelectCity);

  class FieldSelectProductType extends FieldSelectGlobal {
    constructor() {
      super();
      this.initContent();
    }

    initContent() {
      let query = {
        $filter: "contains(suunto_appxs, '1')",
      };
      this.getFetchData(query, true);
      // 监听input输入
      this.labelInput.addEventListener(
        'input',
        debounce((e) => {
          query = {
            $filter: `contains(suunto_appxs, '1') ${e.target.value ? `and contains(new_name, '${e.target.value}')` : ''}`,
          };
          this.getFetchData(query);
        }, 300)
      );
    }
  }
  customElements.define('field-select-product-type', FieldSelectProductType);

  class FieldSelectProductName extends FieldSelectGlobal {
    constructor() {
      super();
      this.queryParams = {
        // 产品类型id
        new_productgroupid: '',
        new_productmodule_id: '',
      };
      this.initContent();
    }

    initContent() {
      this.updateInput();
      // 监听input输入
      this.labelInput.addEventListener(
        'input',
        debounce((e) => {
          const { new_productgroupid, new_productmodule_id } = this.queryParams;
          let query = {
            $filter: `new_productgroupid/id eq ${new_productgroupid} and new_productmodule_id/id eq ${new_productmodule_id} and contains(suunto_appxs, '1') ${e.target.value ? `and contains(name, '${e.target.value}')` : ''}`,
          };
          this.getFetchData(query);
        }, 300)
      );

      // 监听产品类型选项
      const typeInput = document
        .querySelector('#new_productgroup--type')
        .querySelector('.field--input');
      typeInput.addEventListener('input-select', (e) => {
        this.queryParams.new_productgroupid = e.detail.data.value;
        this.queryParams.new_productmodule_id = '';
        this.updateInput();
      });

      // 监听产品型号选项
      const modelInput = document
        .querySelector('#new_productmodel--model')
        .querySelector('.field--input');
      modelInput.addEventListener('input-select', (e) => {
        this.queryParams.new_productmodule_id = e.detail.data.value;
        if (e.detail.data.value && this.queryParams.new_productgroupid) {
          const { new_productgroupid, new_productmodule_id } = this.queryParams;
          this.getFetchData(
            {
              $filter: `new_productgroupid/id eq ${new_productgroupid} and new_productmodule_id/id eq ${new_productmodule_id} and contains(suunto_appxs, '1')`,
            },
            true
          );
        }
        this.updateInput();
      });
    }
    updateInput() {
      const { new_productgroupid, new_productmodule_id } = this.queryParams;
      this.updateInputValue('', false);
      this.labelInput.disabled = !(new_productgroupid && new_productmodule_id);
    }
  }
  customElements.define('field-select-product-name', FieldSelectProductName);

  class FieldSelectProductModel extends FieldSelectGlobal {
    constructor() {
      super();
      this.initContent();
    }

    initContent() {
      this.updateInput();
      // 监听input输入
      this.labelInput.addEventListener(
        'input',
        debounce((e) => {
          let query = {
            $filter: `new_productgroup_id/id eq ${this.productgroup_id} and contains(suunto_appxs, '1') ${e.target.value ? `and contains(new_name, '${e.target.value}')` : ''}`,
          };
          this.getFetchData(query);
        }, 300)
      );

      const fieldInput = document
        .querySelector('#new_productgroup--type')
        .querySelector('.field--input');
      fieldInput.addEventListener('input-select', (e) => {
        this.productgroup_id = e.detail.data.value;
        if (e.detail.data.value) {
          this.getFetchData(
            {
              $filter: `new_productgroup_id/id eq ${e.detail.data.value} and contains(suunto_appxs, '1')`,
            },
            true
          );
        }
        this.updateInput();
      });
    }
    updateInput() {
      this.updateInputValue('', false);
      this.labelInput.disabled = !this.productgroup_id;
    }
  }
  customElements.define('field-select-product-model', FieldSelectProductModel);

  class FieldSelectProductIssue extends FieldSelectGlobal {
    constructor() {
      super();
      this.initContent();
    }

    initContent() {
      this.getFetchData({});
      // 监听input输入
      this.labelInput.addEventListener(
        'input',
        debounce((e) => {
          let query = {
            $filter: `contains(new_name, '${e.target.value}')`,
          };
          this.getFetchData(e.target.value ? query : {});
        }, 300)
      );
    }
  }
  customElements.define('field-select-product-issue', FieldSelectProductIssue);

  class FieldRadio extends HTMLElement {
    constructor() {
      super();
      this.fieldRadios = this.querySelectorAll('.field--radio');
      this.radioInput = this.querySelector('input');
      this.init();
    }
    init() {
      const event = new Event('input-validate', { bubbles: true });
      this.fieldRadios.forEach((fieldRadio) => {
        fieldRadio.addEventListener('click', () => {
          $(this.fieldRadios).not(fieldRadio).removeClass('active');
          fieldRadio.classList.add('active');
          this.radioInput.value = fieldRadio.dataset.value;
          this.radioInput.dispatchEvent(event);
        });
      });
    }
  }

  customElements.define('field-radio', FieldRadio);

  class FieldCheckbox extends HTMLElement {
    constructor() {
      super();
      this.fieldCheckboxList = this.querySelector('.field--checkbox-list');
      this.labelInput = this.querySelector('input');
      this.init();
    }

    init() {
      let jsonString = this.querySelector('.options--json').innerText.trim();
      let options = JSON.parse(jsonString);
      let fragment = document.createDocumentFragment();
      options.forEach((item, index) => {
        const div = document.createElement('div');
        div.classList.add('field--checkbox-option');
        div.setAttribute('data-value', item.value);
        div.setAttribute('data-label', item.label);
        div.innerText = item.label;
        div.addEventListener('click', () => {
          div.classList.toggle('active');
          this.selectOption();
        });
        fragment.appendChild(div);
      });
      this.fieldCheckboxList.appendChild(fragment);
    }
    updateInputValue(data) {
      this.initValues = data || [];
      this.labelInput.setAttribute('data-value', JSON.stringify(this.initValues));
      this.labelInput.value = data?.[0].value;
      // flag是否需要触发input-validate
      this.labelInput.dispatchEvent(
        new CustomEvent('input-validate', {
          bubbles: true,
        })
      );
    }
    selectOption() {
      let checkboxItems = Array.from(
        this.fieldCheckboxList.querySelectorAll('.field--checkbox-option')
      );
      let values = checkboxItems
        .filter((item) => item.classList.contains('active'))
        .map((t) => {
          return {
            value: t.getAttribute('data-value'),
            label: t.getAttribute('data-label'),
          };
        });
      this.updateInputValue(values);
    }
  }

  customElements.define('field-checkbox', FieldCheckbox);

  class FieldFile extends HTMLElement {
    constructor() {
      super();
      this.fieldUpload = this.querySelector('.field-file--upload');
      this.fileWard = this.querySelector('.field-file--ward');
      // this.fileInput = this.querySelector('.field--input')
      this.fieldFileList = this.querySelector('.field-file--list');
      this.accept = this.fieldUpload.getAttribute('accept');
      this.fileData = [];
      this.init();
    }
    init() {
      this.fileWard.addEventListener('click', () => {
        this.fieldUpload.click();
      });

      this.fieldUpload.addEventListener('change', (e) => {
        this.renderFileInfo(
          this.validateFileTypeError(e.target.files) ? [] : Array.from(e.target.files)
        );
      });
    }

    updateHiddenFileInput(files) {
      const dataTransfer = new DataTransfer();
      files.forEach((file) => dataTransfer.items.add(file));
      this.fieldUpload.files = dataTransfer.files;
      if (files.length < 1) {
        this.fieldUpload.value = null;
        this.fieldUpload.files = null;
      }
    }

    // 验证文件类型是否错误
    validateFileTypeError(files = []) {
      return !!Array.from(files).find((file) => !this.accept.includes(file.type));
    }
    renderFileInfo(files) {
      this.fileData = files;
      let htmlStr = ``;
      for (const file of files) {
        let str = `<div class="field-file--list-item">
              <div class="field-file--list-left">
                <span class="field-file--span">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#00993D"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0303 8.46967C17.3232 8.76256 17.3232 9.23744 17.0303 9.53033L10.0932 16.4674L6.96967 13.3439C6.67678 13.051 6.67678 12.5761 6.96967 12.2832C7.26256 11.9903 7.73744 11.9903 8.03033 12.2832L10.0932 14.3461L15.9697 8.46967C16.2626 8.17678 16.7374 8.17678 17.0303 8.46967Z" fill="white"/>
                  </svg>
                </span>
                <div class="field-file--name">${file.name}</div>
              </div>
              <button type="button" class="field-file--delete ">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.6844 6.5L16.9943 20.9983C16.9279 21.5685 16.4186 22 15.8122 22H8.1878C7.5814 22 7.07211 21.5684 7.00567 20.9982L5.31647 6.5H18.6844ZM17.2097 7.75H6.79199L8.30664 20.75H15.6943L17.2097 7.75ZM10.9433 2H13.1147C14.0318 2 14.7811 2.67984 14.83 3.53584L14.8326 3.625L14.8325 4.25H19.5V5.5H4.5V4.25H9.225L9.22543 3.625C9.22543 2.75745 9.94412 2.04869 10.849 2.0024L10.9433 2H13.1147H10.9433ZM13.1151 3.25H10.9437C10.743 3.25 10.5771 3.39108 10.5509 3.57411L10.5472 3.625L10.5469 4.25H13.5114L13.5115 3.625C13.5115 3.43515 13.3624 3.27825 13.1689 3.25342L13.1151 3.25Z" fill="#ACAFB6"/>
  </svg>
              </button>
            </div>`;
        htmlStr = htmlStr.concat(str);
      }
      this.fieldFileList.innerHTML = htmlStr;
      this.updateHiddenFileInput(files);
      this.renderDeleteFileButton();
    }

    renderDeleteFileButton() {
      const deleteButtons = this.fieldFileList.querySelectorAll('.field-file--delete');
      const infoItem = this.fieldFileList.querySelectorAll('.field-file--list-item');
      deleteButtons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
          let newFileData = this.fileData.filter((t, i) => i != index);
          this.updateHiddenFileInput(newFileData);
          infoItem[index].remove();
          // this.renderFileInfo(newFileData)
        });
      });
    }
  }
  customElements.define('field-file', FieldFile);

  class FieldItem extends HTMLElement {
    constructor() {
      super();
      this.emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      this.fieldsErrorMap = new Map();
      this.listenerInput();
    }
    getFieldsError() {
      return this.fieldsErrorMap;
    }

    triggerEvent(element, name, data = {}) {
      element.dispatchEvent(
        new CustomEvent(name, {
          bubbles: true,
          detail: data,
        })
      );
    }

    listenerInput() {
      const input = this.querySelector('.field--input');
      if (input) {
        input.addEventListener('input', (e) => {
          this.validateField(e.target);
        });

        input.addEventListener('input-validate', (e) => {
          this.validateField(e.target);
        });
        input.addEventListener('input-select', (e) => {
          this.validateField(e.target);
        });
      }
    }
    validateField(input) {
      const fieldError = Array.from(input.parentNode.children).find((ele) =>
        ele.classList.contains('field-error--label')
      );
      if (input.ariaRequired == 'true') {
        if (!input.value) {
          let error = input.dataset.error || 'Invalid ' + input.title;
          this.updateInputState({ input, flag: true, error, fieldError });
        } else {
          this.updateInputState({ input, flag: false, fieldError });
        }
      }
      if (input.type == 'file' && input.value) {
        if (this.isValidFile(input.files, input)) {
          this.updateInputState({
            input,
            fieldError,
            flag: true,
            error: 'Wrong file type, please re-upload',
          });
        } else {
          this.updateInputState({ input, flag: false, fieldError });
        }
      }

      if (input.type == 'email' && input.value) {
        if (!this.isValidEmail(input.value)) {
          this.updateInputState({
            input,
            fieldError,
            flag: true,
            error: 'Incorrect email address format',
          });
        } else {
          this.updateInputState({ input, flag: false, fieldError });
        }
      }
    }

    isValidEmail(value) {
      return this.emailPattern.test(value);
    }

    // 验证文件类型是否错误
    isValidFile(files = [], target) {
      return !!Array.from(files).find((file) => !target.getAttribute('accept').includes(file.type));
    }

    updateInputState({ input, flag, error, fieldError }) {
      if (flag) {
        input.classList.add('input--error');
        fieldError.classList.add('visible');
        fieldError.innerText = error;
        if (!this.fieldsErrorMap.has(input.name)) {
          this.fieldsErrorMap.set(input.name, error);
        }
      } else {
        input.classList.remove('input--error');
        fieldError.classList.remove('visible');
        if (this.fieldsErrorMap.has(input.name)) {
          this.fieldsErrorMap.delete(input.name);
        }
      }
    }
  }

  customElements.define('field-item', FieldItem);

  class FieldForm extends FieldItem {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.initForm();
    }
    initForm() {
      this.form.addEventListener('submit', async (e, value) => {
        e.preventDefault();
        Array.from(e.target).forEach((input) => {
          this.validateField(input);
        });
      });
    }

    finish() {
      let hiddenValues = {};
      Array.from(this.form).forEach((elementInput) => {
        if (elementInput.classList.contains('field--input')) {
          this.validateField(elementInput);
        }
        if (elementInput.classList.contains('field--input--select')) {
          hiddenValues[elementInput.name] = JSON.parse(elementInput.dataset.value || '{}');
        }
      });
      let formValues = {
        errors: Object.fromEntries(this.getFieldsError()),
        values: { ...Object.fromEntries(new FormData(this.form)), ...hiddenValues },
      };
      return formValues;
    }
  }
  customElements.define('field-form', FieldForm);

  class VideoLazyLoad extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.videos = document.querySelectorAll('.video--lazyLoad');
      // 人机是否有交互
      this.interactState = false;
      this.autoplayMap = [];
      // this.listenerIntersectionObserver()
      this.listenerInteract();
      this.listenerALick();
    }

    listenerIntersectionObserver() {
      const _this = this;
      this.videoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach((entry) => {
          let video = entry.target;
          if (entry.isIntersecting) {
            video.src = video.dataset.src;
            if (video.dataset.poster) {
              video.poster = video.dataset.poster;
            }
            if (video.dataset.autoplay) {
              // 有交互性则自动播放
              video.play();
              // _this.interactState ? video.play() : _this.autoplayMap.push(video)
            }

            // observer.unobserve(entry.target);
          } else {
            // 不在可视区暂停播放
            video.src && video.pause();
          }
        });
      });

      this.videos.forEach((item) => {
        this.videoObserver.observe(item);
      });
    }
    listenerInteract() {
      const startEvent = () => {
        this.listenerIntersectionObserver();
        // this.interactState = true
        // this.autoplayMap.forEach(video => video.play())
      };
      document.addEventListener('mousemove', startEvent, { once: true });
      document.addEventListener('touchstart', startEvent, { once: true });
    }

    listenerALick() {
      document.addEventListener('click', (event) => {
        if (
          event.target.tagName === 'A' &&
          event.target.getAttribute('href') &&
          this.videos.length
        ) {
          this.videos.forEach((video) => video.pause());
        }
      });
    }
  }
  customElements.define('video-lazy-load', VideoLazyLoad);

  class DiscountCode extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      this.tim = 0;
      this.copy_text = this.querySelector('.copy-text');
      const copy_btn = this.querySelector('#copy-discount-code');
      const code = this.querySelector('.code').innerText;
      copy_btn.addEventListener('click', () => {
        this.copyTextToClipboard(code);
      });
    }
    copyTextToClipboard(code) {
      const _this = this;
      if (navigator.clipboard) {
        // 如果浏览器支持 Clipboard API
        navigator.clipboard
          .writeText(code)
          .then(function () {
            _this.copySuccess();
          })
          .catch(function (error) {
            _this.copyTextToClipboard2(code);
            console.error('复制失败: ', error);
          });
      } else {
        _this.copyTextToClipboard2(code);
      }
    }

    copyTextToClipboard2(code) {
      // 对不支持 Clipboard API 的浏览器使用传统方法
      let textArea = document.createElement('textarea');
      textArea.value = code;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      this.copySuccess();
    }
    copySuccess() {
      clearTimeout(this.tim);
      this.copy_text.innerText = 'Copied';
      this.tim = setTimeout(() => {
        this.copy_text.innerText = 'Copy code';
      }, 3000);
    }
  }
  customElements.define('discount-code', DiscountCode);
  class ProductItemVariants extends HTMLElement {
    static get observedAttributes() {
      return ['open'];
    }
    get open() {
      return this.hasAttribute('open');
    }
    set open(value) {
      if (value) {
        (async () => {
          this.setAttribute('open', '');
        })();
      } else {
        this.removeAttribute('open');
      }
    }
    constructor() {
      super();
      this.init();
    }
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case 'open':
          if (this.hasAttribute('open')) {
            this.init();
          }
      }
    }
    init() {
      this.itemVariants = this.querySelectorAll('.item-variant');
      if (!this.itemVariants.length) return;
      this.itemVariants.forEach((item) => {
        item.onclick = () => {
          this.selectItem(item);
        };
      });
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.selectItem(this.itemVariants[0]);
      }, 100);
    }
    selectItem(item) {
      if (this.activeItem == item) return;
      this.activeItem = item;
      $(this.itemVariants).not(item).removeClass('active');
      item.classList.add('active');
      this.querySelector('.product-item-variants--sold').setAttribute(
        'data-available',
        item.dataset.available
      );
      this.querySelector('.title--h1').innerText = item.dataset.h1;
      this.querySelector('.title--h2').innerText = item.dataset.h2;
      this.querySelector('.product-item-variants--des').innerText = item.dataset.description;
      this.querySelector('.product-item-variants-button').href = item.dataset.url;

      if (Number(item.dataset.sourceOriginalPrice) > Number(item.dataset.sourcePrice)) {
        this.querySelector('.original-price').innerText = item.dataset.originalPrice;
        this.querySelector('.discount-amount').innerText = item.dataset.price;
        this.querySelector('.product-item-variants-price').innerText = '';
      } else {
        this.querySelector('.product-item-variants-price').innerText = item.dataset.price;
        this.querySelector('.original-price').innerText = '';
        this.querySelector('.discount-amount').innerText = '';
      }

      this.querySelector('.product-item-image--link').href = item.dataset.url;
      const image = this.querySelector('.product-item-image');
      image.setAttribute('data-src', item.dataset.image);
      image.src = item.dataset.image;
      this.querySelector('.rotation-loading').classList.remove('hidden');
      image.onload = () => {
        this.querySelector('.rotation-loading').classList.add('hidden');
      };
      image.onerror = () => {
        this.querySelector('.rotation-loading').classList.add('hidden');
      };
    }
  }
  customElements.define('product-item-variants', ProductItemVariants);
  customElements.define(
    'product-collection-tags',
    class ProductCollectionTags extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const items = this.querySelectorAll('.collection-tags-item-title');
        $(items).click(function () {
          // 切换父元素的 hidden 类
          $(this).next().slideToggle();
          $(this).toggleClass('open');
        });
      }
    }
  );

  customElements.define(
    'watch-race-video-crown',
    class WatchRaceVideoCrown extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        if (this.getBrowserWidth() < 768) return;
        const content = this.querySelector('.watch-race-video-crown-content');
        const video = this.querySelector('video');
        video.addEventListener('timeupdate', function () {
          let currentTime = video.currentTime;
          let duration = video.duration;
          if (currentTime >= duration - 1.5) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });
      }
      getBrowserWidth() {
        return (
          window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        );
      }
    }
  );
  customElements.define(
    'add-cart-fixed',
    class AddCartFixed extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const productForm = document.querySelector('.product-form__buy-buttons');
        if (!productForm) return;
        const addCart = this.querySelector('#add-cart-fixed');
        const intersection = new IntersectionObserver(function (entries, observer) {
          entries.forEach((entry) => {
            entry.isIntersecting ? addCart.classList.remove('open') : addCart.classList.add('open');
          });
        });
        intersection.observe(productForm);
      }
    }
  );

  customElements.define(
    'collection-filters',
    class CollectionWatches extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const _this = this;
        const itemTags = this.querySelectorAll('.collection-item--tag');
        const filtersClose = this.querySelector('.filters-close');
        const filtersOpen = this.querySelector('.filters-open');
        const collectionFixedModal = this.querySelector('.collection--fixed');
        const sortFilterDown = this.querySelector('.sort-filter-down');
        const sortContainer = this.querySelector('#sort-filter--container');
        itemTags.forEach((item) => {
          item.addEventListener('click', () => {
            item.classList.toggle('open');
            $(item.nextSibling).slideToggle();
          });
        });

        filtersOpen.addEventListener('click', () => {
          collectionFixedModal.classList.add('open');
        });
        filtersClose.addEventListener('click', () => {
          collectionFixedModal.classList.remove('open');
        });

        this.querySelector('.sort-filter-close').addEventListener('click', (event) => {
          _this.handleClick(event);
        });
        sortFilterDown.addEventListener('click', (event) => {
          _this.handleClick(event);
        });

        this.querySelector('.sort-filter-fixed').addEventListener('click', function (event) {
          _this.handleClick(event);
        });

        document.addEventListener('click', (element) => {
          if (this.getBrowserWidth() > 780) {
            sortContainer.classList.contains('open') && sortContainer.classList.remove('open');
          } else if (!element.target.classList.contains('sort-filter-list')) {
            sortContainer.classList.contains('open') && sortContainer.classList.remove('open');
          }
        });
      }

      handleClick(event) {
        event.stopPropagation();
        this.querySelector('#sort-filter--container').classList.toggle('open');
      }
      getBrowserWidth() {
        return (
          window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        );
      }
    }
  );

  customElements.define(
    'mobile-menu-fixed',
    class MobileMenuFixed extends HTMLElement {
      static get observedAttributes() {
        return ['open'];
      }
      constructor() {
        super();
        this.init();
      }
      attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
          case 'open':
            // if (this.initDrop) {
            //     this.initDrawer();
            // }
            this.open
              ? document.body.classList.add('overflow-hidden')
              : document.body.classList.remove('overflow-hidden');
        }
      }

      init() {
        this.querySelector('.mobile-close-icon').addEventListener('click', () => {
          this.removeAttribute('open');
        });

        const items = this.querySelectorAll('.mobile-menu-item--title');
        const container = this.querySelectorAll('.mobile-menu--container');
        items.forEach((item, index) => {
          item.addEventListener('click', () => {
            $(item).toggleClass('open');
            $(item.nextElementSibling).slideToggle();
          });
        });
      }
    }
  );

  customElements.define(
    'section-partners-content',
    class SectionPartnersContent extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const items = this.querySelectorAll('.section-partners-left-item');
        const items_text = this.querySelectorAll('.section-partners-left-text');
        const images = this.querySelectorAll('.section-partners--image');
        const images_img = this.querySelectorAll('.section-partners--image-img');
        const isMdImage = this.dataset.mdImage;
        const mdImage = this.querySelectorAll('.section-partners--image-md');

        const selectItem = (item, index) => {
          item.classList.add('active');
          $(items).not(item).removeClass('active');
          $(items_text[index]).slideDown();
          $(items_text).not(items_text[index]).slideUp();
          $(images).not(images[index]).removeClass('active');
          images[index].classList.add('active');

          if(isMdImage) {
            $(mdImage).removeClass('active').addClass('h-0');
            $(mdImage[index]).addClass('active').removeClass('h-0');
          }
        };

        selectItem(items[0], 0);

        items.forEach((item, index) => {
          item.addEventListener('click', () => {
            selectItem(item, index);
          });
        });
      }
    }
  );

  customElements.define(
    'global-tabs',
    class SectionPartnersContent extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const tabs = this.querySelectorAll('.global-tab');
        const swiperContainer = document.querySelector('#' + this.dataset.swiperId)?.swiper;
        this.updateSlider(tabs[0]);
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            $(tabs).not(tab).removeClass('active');
            swiperContainer.slideTo(index);
            this.tab_current = index;
            this.updateSlider(tab);
            document.dispatchEvent(
              new CustomEvent('select-tab', {
                bubbles: true,
                detail: {
                  element: tab,
                },
              })
            );
          });
        });
      }
      updateSlider(item) {
        if (item) {
          item.classList.add('active');
          const { offsetLeft, offsetWidth } = item;
          $(this).css({
            ['--global-tab-left']: offsetLeft + 'px',
            ['--global-tab-width']: offsetWidth + 'px',
          });
        }
      }
    }
  );

  customElements.define(
    'orders-info-content',
    class OrdersInfoContent extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const items = this.querySelectorAll('.orders-info-title');
        items.forEach((item, index) => {
          item.addEventListener('click', () => {
            $(item.nextElementSibling).slideToggle();
            $(item).toggleClass('active');
          });
        });
      }
    }
  );

  customElements.define(
    'auto-height',
    class AutoHeight extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const options = this.dataset.options?.split(',');
        options.forEach((clsName) => {
          const items = Array.from(this.querySelectorAll('.' + clsName));
          if (items.length) {
            const maxHeight = Math.max(...items.map((k) => k.offsetHeight));
            items.forEach((element) => {
              element.style.height = maxHeight + 'px';
            });
          }
        });
      }
    }
  );

  customElements.define(
    'param-content',
    class ParamContent extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        const tabsContainer = this.querySelector('.section-collection--tabs');
        if (!tabsContainer) return;
        const btn = this.querySelector('.collection--select-btn');
        btn.addEventListener('click', () => {
          btn.classList.toggle('active');
          $(tabsContainer).slideToggle();
        });
        document.addEventListener('click', (e) => {
          if (e.target != btn && btn.classList.contains('active')) {
            $(tabsContainer).slideUp();
            btn.classList.toggle('active');
          }
        });
        document.addEventListener('select-tab', (e) => {
          btn.innerText = e.detail.element.innerText;
          // if (this.getBrowserWidth() <= 768) {
          //     $(tabsContainer).slideUp()
          // }
        });
      }
      getBrowserWidth() {
        return (
          window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        );
      }
    }
  );

  customElements.define(
    'article-content',
    class ArticleContent extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const images = this.querySelectorAll('img');
        const iframes = this.querySelectorAll('iframe');

        const intersectionObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              let target = entry.target;
              target.src = target.dataset.src;
              observer.unobserve(target);
            }
          });
        });

        images.forEach((item) => {
          intersectionObserver.observe(item);
        });
        iframes.forEach((item) => {
          intersectionObserver.observe(item);
        });
      }
    }
  );

  customElements.define(
    'param-card',
    class ParamCard extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        const swiper = this.querySelector('swiper-component').swiper;
        this.itemVariants = this.querySelectorAll('.metafields-swiper--slide');
        swiper.on('click', (e) => {
          e.clickedSlide && this.selectItem(e.clickedSlide);
        });
      }

      selectItem(item) {
        if (this.activeItem == item) return;
        this.activeItem = item;
        $(this.itemVariants).not(item).removeClass('active');
        item.classList.add('active');
        this.querySelector('.param-item-h1').innerText = item.dataset.h1;
        if (this.querySelector('.param-item-h2')) {
          this.querySelector('.param-item-h2').innerText = item.dataset.h2;
        }
        this.querySelector('.param-item-description').innerText = item.dataset.description;
        this.querySelectorAll('.param-item-link').forEach((t) => (t.href = item.dataset.url));
        this.querySelector('.param-item-price').innerText = item.dataset.price;
        const image = this.querySelector('.param-item-image');
        this.querySelector('.rotation-loading').classList.remove('hidden');
        image.src = item.dataset.image;
        image.onload = () => {
          this.querySelector('.rotation-loading').classList.add('hidden');
        };
        image.onerror = () => {
          this.querySelector('.rotation-loading').classList.add('hidden');
        };
      }
    }
  );

  /**
   * 倒计时组件 - 自定义Web Component
   *
   * 用法示例:
   * <countdown-timer target="2025-07-22T08:00:00Z">
   *   <span type="days">00</span>
   *   <span type="hours">00</span>
   *   <span type="minutes">00</span>
   *   <span type="seconds">00</span>
   * </countdown-timer>
   *
   * 属性:
   * - target: 目标结束时间 (ISO 8601格式，如: "2025-07-22T08:00:00Z")
   * - data-container: 可选，指定一个容器ID，当倒计时结束时隐藏该容器
   *
   * 功能特性:
   * - 实时显示距离目标时间的倒计时（天:时:分:秒）
   * - 自动清理定时器防止内存泄漏
   * - 支持页面内多个倒计时组件同时运行
   * - 通过type属性识别不同的时间单位元素
   * - 当倒计时结束时自动停止并显示00:00:00:00
   */
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends GlobalHTMLElement {
      constructor() {
        super();
        this.interval = null;
      }

      connectedCallback() {
        const targetTime = this.getAttribute('target');
        if (!targetTime) {
          console.error("Missing 'target' attribute.");
          return;
        }

        this.targetDate = new Date(targetTime);
        if (isNaN(this.targetDate)) {
          return;
        }

        this.startCountdown();
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      startCountdown() {
        const update = () => {
          const now = new Date();
          const diff = this.targetDate - now;

          if (diff <= 0) {
            clearInterval(this.interval);
            this.updateDisplay('00', '00', '00', '00');
            return;
          }

          const seconds = Math.floor((diff / 1000) % 60)
            .toString()
            .padStart(2, '0');
          const minutes = Math.floor((diff / 1000 / 60) % 60)
            .toString()
            .padStart(2, '0');
          const hours = Math.floor((diff / 1000 / 60 / 60) % 24)
            .toString()
            .padStart(2, '0');
          const days = Math.floor(diff / 1000 / 60 / 60 / 24)
            .toString()
            .padStart(2, '0');

          this.updateDisplay(days, hours, minutes, seconds);
        };

        update();
        this.interval = setInterval(update, 1000);
      }

      updateDisplay(days, hours, minutes, seconds) {
        const daysElement = this.querySelector('[type="days"]');
        const hoursElement = this.querySelector('[type="hours"]');
        const minutesElement = this.querySelector('[type="minutes"]');
        const secondsElement = this.querySelector('[type="seconds"]');

        if (daysElement) daysElement.textContent = days;
        if (hoursElement) hoursElement.textContent = hours;
        if (minutesElement) minutesElement.textContent = minutes;
        if (secondsElement) secondsElement.textContent = seconds;
      }
    }
  );
  /**
   * 加载更多组件 - 自定义 Web Component
   *
   * 用法示例:
   * <load-more data-total="16" data-count="4" available="true">
   *   <div slot="product-list">
   *     <div class="product-snippet" style="display: none;">商品1</div>
   *     <div class="product-snippet" style="display: none;">商品2</div>
   *     <div class="product-snippet" style="display: none;">商品3</div>
   *     ...
   *   </div>
   *   <button class="load-more">加载更多</button>
   * </load-more>
   *
   * 属性:
   * - data-total: 商品总数（必填，数字）
   * - data-count: 每次点击加载的商品数量（必填，数字）
   * - data-item-selector: 商品元素选择器（可选，默认为 ".product-snippet"）
   *
   * 功能特性:
   * - 初始化时自动显示第一批商品（count 数量）
   * - 点击“加载更多”按钮时，展示接下来的 count 个商品
   * - 超过总数后自动禁用加载，available 属性变为 false（可用于按钮隐藏或禁用）
   * - 所有商品元素必须带有 class="product-snippet"，并初始隐藏（如 style="display: none;"）
   * - 商品列表容器需要放在 slot="product-list" 中
   *
   * 注意事项:
   * - 组件不会负责数据拉取，所有商品应在页面中直出（SSR或Liquid 渲染）
   */
  customElements.define(
    'load-more',
    class LoadMore extends HTMLElement {
      constructor() {
        super();
        this.total = parseInt(this.dataset.total);
        this.count = parseInt(this.dataset.count);
        this.currentIndex = 0;
        this.productList = this.querySelector("[slot='product-list']");
        this.loadBtn = this.querySelector('.load-more');
        this.foldBtn = this.querySelector('.fold-up');
      }

      connectedCallback() {
        this.items = this.productList.querySelectorAll(
          this.dataset.itemSelector || '.product-snippet'
        );
        if (this.total > this.count) {
          this?.loadBtn?.addEventListener('click', () => this.loadMore());
          this?.foldBtn?.addEventListener('click', () => this.foldUp());
        }
        this.loadMore(); // 初始化展示一批
      }

      loadMore() {
        // 修复：当total小于count时，正常展示全部商品
        const showCount = Math.min(this.count, this.total);
        const next = this.currentIndex + showCount;
        for (let i = this.currentIndex; i < next && i < this.total; i++) {
          const el = this.items[i];
          if (el) el.style.display = '';
        }
        this.currentIndex += showCount;
        this.setAttribute('available', String(this.currentIndex < this.total));
      }

      foldUp() {
        this.items.forEach((item, index) => {
          if (index >= this.count) {
            item.style.display = 'none';
          }
        });
        this.currentIndex = this.count;
        this.setAttribute('available', String(this.currentIndex < this.total));
        // 滚动到load-more按钮位置
        if (this.loadBtn) {
          this.loadBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  );
})();
